import * as Yup from 'yup'
import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const TransactionsDefaultSchemas = DefaultSchemas

export const BulkTransactionsTxSchemas = Yup.object().shape({
  batchId: Yup.number().required('Batch is required'),
  transactionTypeId: Yup.number(),
  fromTraderId: Yup.number(),
  deviceCode: Yup.number().nullable(),
  toTraderIds: Yup.array().of(Yup.number()),
  transactionDate: Yup.string(),
  purchaseValue: Yup.number(),
  voucherValue: Yup.number(),
  loyaltyValue: Yup.number(),
  creditValue: Yup.number(),
  paymentMethodId: Yup.number().nullable(),
  manualEntryTypeId: Yup.number().nullable(),
  glCode: Yup.string().nullable(),
  addToCode: Yup.string().nullable(),
  consolidationCode: Yup.string().nullable(),
  comments: Yup.string().nullable(),
  custom1: Yup.string().nullable(),
  custom2: Yup.string().nullable(),
  custom3: Yup.string().nullable(),
  flTest: Yup.number(),
  flManualOverride: Yup.number(),
  flOnline: Yup.number(),
})

export const BatchLookupTxSchemas = zod.object({
  batchId: zod.number().nullable(),
  batchName: zod.string().nullable(),
  batchStatusId: zod.number().nullable(),
  dataSourceTypeId: zod.number().nullable(),
  traderTypeId: zod.number().nullable(),
  flTest: zod.number().nullable(),
  flBusiness: zod.number().nullable(),
  flGeneric: zod.number().nullable(),
  traderCountMinimum: zod.number().nullable(),
  traderCountMaximum: zod.number().nullable(),
  tradersMaximumMin: zod.number().nullable(),
  tradersMaximumMax: zod.number().nullable(),
  identTypeId: zod.number().nullable(),
  identCreationModeId: zod.number().nullable(),
})
